import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { useLanguageContext } from "../../Context/LanguageContext";
import { AiOutlineFolderView, AiOutlineDelete } from "react-icons/ai";
import ExceptionAnalysisDetails from "./ExceptionAnalysisDetails";
import ExceptionAnlysisActions from "../../Actions/ExceptionAnalysisActions";
import exceptionStore from "../../Stores/ExceptionAnalysisStore";
import ExceptionConstants from "../../Constants/ExceptionAnalysisConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";

function ExceptionAnalysis() {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [methodInfo, setMethodInfo] = useState("");
  const [occurredInDays, setOccurredInDays] = useState("");
  const [isValidation, setIsValidation] = useState(-1);
  const [allExcRes, setAllExcRes] = useState([]);
  const [selectedExcId, setSelectedExcId] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [showDelButton, setShowDelButton] = useState(true);
  const perviousSearchRef = useRef("");
  const type = [
    {
      id: -1,
      name: localization.all,
    },
    {
      id: 0,
      name: localization.error,
    },
    {
      id: 1,
      name: localization.validation,
    },
    {
      id: 2,
      name: localization.mobile,
    },
  ];
  function ExceptionAnalysisRecord(serachItem) {
    ExceptionAnlysisActions.getExceptionAnalysisLogs(serachItem);
  }

  /**-------------------------------------------------------------------set Exception Result Start---------------------------------------------------- */

  useEffect(() => {
    function getAllexceptionSuccess() {
      var res = exceptionStore.getAllExceptionResult();
      if (res.length > 0) {
        setAllExcRes(res);
        setShowTable(true);
        setShowDelButton(false);
      } else {
        setAllExcRes([]);
        setShowTable(true);
        setShowDelButton(true);
      }
      setGlobalSpinner(false);
    }

    function getAllexceptionFailure() {
      var res = exceptionStore.getAllExceptionResult();
      toast.error(res);
      setGlobalSpinner(false);
      setShowDelButton(true);
    }

    exceptionStore.addChangeListener(
      ExceptionConstants.GET_ALL_EXCEPTION_LOG_SUCCESS,
      getAllexceptionSuccess,
    );

    exceptionStore.addChangeListener(
      ExceptionConstants.GET_ALL_EXCEPTION_LOG_FAILURE,
      getAllexceptionFailure,
    );
    return () => {
      exceptionStore.removeChangeListener(
        ExceptionConstants.GET_ALL_EXCEPTION_LOG_SUCCESS,
        getAllexceptionSuccess,
      );

      exceptionStore.removeChangeListener(
        ExceptionConstants.GET_ALL_EXCEPTION_LOG_FAILURE,
        getAllexceptionFailure,
      );
    };
  }, []);
  /**-------------------------------------------------------------------set Exception Result End---------------------------------------------------- */

  /**-------------------------------------------------------------------Render Button Start---------------------------------------------------- */
  function RenderViewButton(props) {
    const excId = props.id;
    return (
      <AiOutlineFolderView
        className="mr-1 cursorPoint svgIcon"
        title={localization.exceptionDetails}
        size={20}
        onClick={() => {
          setSelectedExcId(excId);
        }}
        data-toggle="modal"
        data-target="#exceptionAnalysisDetails"
      />
    );
  }

  function RenderDeleteButton(props) {
    const id = props.id;
    return (
      <AiOutlineDelete
        className="ml-0 cursorPoint svgIcon"
        title={localization.delete}
        size={20}
        onClick={() => {
          deleteExc(id);
        }}
      />
    );
  }
  /**-------------------------------------------------------------------Render Button End---------------------------------------------------- */

  /**-------------------------------------------------------------------Delete Single Eception Start---------------------------------------------------- */

  useEffect(() => {
    function deleteExcSuccess() {
      toast.success(localization.exceptionDelete);
      ExceptionAnalysisRecord(perviousSearchRef.current);
    }
    function deleteExcFailure() {
      const res = exceptionStore.getExceptionDeleteResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    exceptionStore.addChangeListener(
      ExceptionConstants.DELETE_EXCEPTION_SUCCESS,
      deleteExcSuccess,
    );

    exceptionStore.addChangeListener(
      ExceptionConstants.DELETE_EXCEPTION_FAILURE,
      deleteExcFailure,
    );

    return () => {
      exceptionStore.removeChangeListener(
        ExceptionConstants.DELETE_EXCEPTION_SUCCESS,
        deleteExcSuccess,
      );

      exceptionStore.removeChangeListener(
        ExceptionConstants.DELETE_EXCEPTION_FAILURE,
        deleteExcFailure,
      );
    };
  }, []);

  const deleteExc = (id) => {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.deleteConfirmation);
    setCallbackData({
      ID: id,
    });
    setEventType("DELETE_EXCEPTION");
  };
  /**-------------------------------------------------------------------Delete Single Eception End---------------------------------------------------- */

  /**-------------------------------------------------------------------Delete Multiple Eception Start---------------------------------------------------- */

  useEffect(() => {
    function deleteMulExcSuccess() {
      toast.success(localization.exceptionDelete);
      ExceptionAnalysisRecord(perviousSearchRef.current);
    }
    function deleteMulExcFailure() {
      const res = exceptionStore.getMulExceptionDeleteResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    exceptionStore.addChangeListener(
      ExceptionConstants.DELETE_MUL_EXCEPTION_SUCCESS,
      deleteMulExcSuccess,
    );

    exceptionStore.addChangeListener(
      ExceptionConstants.DELETE_MUL_EXCEPTION_FAILURE,
      deleteMulExcFailure,
    );

    return () => {
      exceptionStore.removeChangeListener(
        ExceptionConstants.DELETE_MUL_EXCEPTION_SUCCESS,
        deleteMulExcSuccess,
      );

      exceptionStore.removeChangeListener(
        ExceptionConstants.DELETE_MUL_EXCEPTION_FAILURE,
        deleteMulExcFailure,
      );
    };
  }, []);
  const handleDelMultipleExc = () => {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.deleteConfirmation);
    setCallbackData({
      serachItem: perviousSearchRef.current,
    });
    setEventType("DELETE_MUL_EXCEPTION");
  };

  /**-------------------------------------------------------------------Delete Multiple Eception Start---------------------------------------------------- */

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_EXCEPTION":
          setGlobalSpinner(true);
          const res = ExceptionAnlysisActions.deleteException(data.ID);
          closePopUpCallback();
          break;
        case "DELETE_MUL_EXCEPTION":
          setGlobalSpinner(true);
          const result = ExceptionAnlysisActions.deleteMultipleException(
            data.serachItem,
          );
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  function handleExceptionSearch(e) {
    e.preventDefault();
    setAllExcRes([]);
    const filterFiled = {
      MethodInfo: methodInfo,
      OccurredInDays: occurredInDays,
      IsValidation: parseInt(isValidation),
    };
    perviousSearchRef.current = filterFiled;
    setGlobalSpinner(true);
    ExceptionAnalysisRecord(filterFiled);
  }
  const validationType = (typeValue) => {
    let nameType = "";
    type.map((item) => {
      if (item.id === typeValue) {
        nameType = item.name;
        return;
      }
    });
    return nameType;
  };
  return (
    <>
      <div className="w-100 h-100">
        <div className="container-fluid">
          <form
            id="searchPanel"
            name="searchPanel"
            onSubmit={handleExceptionSearch}
          >
            <div className="row ml-3">
              <div className="col-3">
                <div className="form-group">
                  <label htmlFor="methodInfo" className="mr-3">
                    {localization.methodInfo}
                  </label>
                  <input
                    type="text"
                    id="methodInfo"
                    name="methodInfo"
                    className="form-control"
                    value={methodInfo}
                    onChange={(e) => {
                      setMethodInfo(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="form-group">
                  <label htmlFor="occurredOn" className="mr-3">
                    {localization.occurredOn}
                  </label>
                  <input
                    type="text"
                    id="occurredOn"
                    name="occurredOn"
                    max={365}
                    className="form-control"
                    value={occurredInDays}
                    onChange={(e) => {
                      setOccurredInDays(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="form-group">
                  <label htmlFor="validation" className="mr-3">
                    {localization.validation}
                  </label>
                  <select
                    className="form-control"
                    id="validation"
                    name="validation"
                    value={isValidation}
                    onChange={(e) => {
                      setIsValidation(e.target.value);
                    }}
                  >
                    {type.map((item, i) => {
                      return (
                        <option value={item.id} key={i}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col mt-5 d-flex">
                <div className="form-group  align-items-center">
                  <button type="submit" className="btn btn-primary">
                    {localization.search}
                  </button>
                </div>
                <div className="form-group  align-items-center ml-3">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      setIsValidation(-1);
                      setMethodInfo("");
                      setOccurredInDays("");
                    }}
                  >
                    {localization.reset}
                  </button>
                </div>

                <div className="form-group  align-items-center ml-3">
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={showDelButton}
                    onClick={() => {
                      handleDelMultipleExc();
                    }}
                  >
                    {localization.delete}
                  </button>
                </div>
              </div>
            </div>
          </form>
          {showTable && (
            <div className="row">
              <div className="col pl-0 ">
                <div className="table-responsive px-3  excAllTabelHeig">
                  <table className="table align-middle mb-0 table-striped table-hover table-sticky">
                    <thead className="bg-light">
                      <tr>
                        <th>{localization.srNo}</th>
                        <th>{localization.id}</th>
                        <th>{localization.message}</th>
                        <th>{localization.dateTime}</th>
                        <th>{localization.methodInfo}</th>
                        <th>{localization.validation}</th>
                        <th>{localization.action}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {allExcRes.length > 0 ? (
                          allExcRes.map((item, i) => {
                            return (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{item.id}</td>
                                <td>{item.message}</td>
                                <td>{item.dateTime}</td>
                                <td>{item.methodInfo}</td>
                                <td>{validationType(item.logType)}</td>
                                <td className="d-flex">
                                  <RenderViewButton id={item.id} />
                                  <RenderDeleteButton id={item.id} />
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <>
                            <tr>
                              <td className="text-center" colSpan={100}>
                                <p>{localization.noRecordFound}</p>
                              </td>
                            </tr>
                          </>
                        )}
                      </>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />

      <ExceptionAnalysisDetails excId={selectedExcId} />
    </>
  );
}
export default ExceptionAnalysis;
